import { $http } from '@/utils';
const _iotCenter = true ? '/iot-center' : '';

/**
 * 统计分析
 *
*/

// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //获取抄表成功率列表数据
    getSuccessRateList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryReading', data);
    },

    //获取断线排名列表数据
    getBreakRanksList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryDisconnection', data);
    },

    //获取通讯质量列表数据
    getCommunicationQualityList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryComQA', data);
    },

    //获取 网关运行图 列表数据
    getRunEchartsList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryComQARun', data);
    },

    //获取 设备异常 通过采集点 列表数据
    getNormalsOfPointList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryExceptionByCollectPoint', data);
    },

    //获取设备异常 通过网关or设备 列表
    getNormalsOfGatewayOrDeviceList(data) {
        return $http.get(_iotCenter + '/dev-sta/queryExceptionByDevice', data);
    },

    //设置设备异常处理意思
    setDealOpinion(data) {
        return $http.post(_iotCenter + '/dev-sta/dealMessage', null, data);
    },

}
